import styled from "@emotion/styled";
import { units } from "../../../../types/units";
import { Typography, FormLabel } from "@material-ui/core";

export const TodayHeader = styled(Typography)`
  ${units({
    fontSize: "1.5rem",
    marginLeft: "16px",
  })}
`;
export const ViewLabel = styled(FormLabel)`
  display: none;
`;
